@if (!to.hideControl) {
  <app-profession-selector
    [multi]="to.multi"
    [required]="false"
    [all]="to.all"
    [profession]="to.profession"
    [candidateOrganizationId]="formState.organizationId"
    [showClear]="to.showClear"
    [readonly]="to.readonly"
    [formControl]="$any(formControl)"
    [language]="to.language"
  ></app-profession-selector>
}
